import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ProgressBar } from 'app/components';
import {
  bookTicket,
  getEventById,
  getPlatformDetails,
  updateUserContact,
} from './api';
import './style';
import {
  Step2,
  Step_3,
  SubStep1,
  SubStep2,
  Step42,
  Step_41,
  Landing,
  ForwardModal,
} from './components';
import { Button, notify } from '../../components';
import {
  validateTicketCount,
  validateTicketPrice,
} from './components/validatorUtils';
import mixpanel from 'mixpanel-browser';

const Footer = (props) => {
  const {
    onClickBack,
    onClickNext,
    currentStep,
    isModalOpen,
    subStep,
    userContactData,
  } = props;

  // Function to check if the contact number is present and valid (10 digits)
  const isContactNumberValid = (contactData) => {
    return contactData?.phone && /^\d{10}$/.test(contactData.phone);
  };

  return (
    <footer className="footer-container flex w-full items-center justify-between py-2 mt-0">
      {/* Back button is hidden on mobile and shown on desktop */}
      {currentStep >= 2 && currentStep < 3 && isModalOpen ? (
        <Button type="tertiary-text-underlined"
          onClick={onClickBack}>
          Back
        </Button>
      ) : (
        <Button
          type="tertiary-text-underlined"
          onClick={onClickBack}
          className={'hidden md:block'}
        >
          Back
        </Button>
      )}

      <Button
        onClick={onClickNext}
        disabled={
          currentStep === 4 &&
    subStep === 1 &&
    !isContactNumberValid(userContactData)
        }
        className={`footer-button md:text-base`}
      >
        {currentStep >= 2 && currentStep < 3 && isModalOpen
          ? 'I\'ve forwarded my tickets!'
          : currentStep === 2
            ? 'I\'ve forwarded my tickets!'
            : currentStep === 4 && subStep === 1
              ? (
                <>
                  <span className="block md:hidden">List My Tickets</span>
                  <span className="hidden md:block">Next</span>
                </>
              )
              : 'Next'}
      </Button>

    </footer>
  );
};

const SellTickets = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [subStep, setSubStep] = useState(1);
  const [progress, setProgress] = useState(16.62);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCheckModalOpen, setIsCheckModalOpen] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState(null);
  const [error, setError] = useState({});

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { userData } = useSelector((state) => state.app);
  const { eventData, userContactData, ticketData, verificationData } =
    useSelector((state) => state.sellTickets);

  useEffect(() => {
    if (location?.state?.eventId) {
      getEventById(location.state.eventId, () => {
        updateSubStep(2);
        setError({});
      });
    } else {
      console.error('Event ID not found in location state');
    }
  }, [location?.state?.eventId]);

  // Update progress based on the current step and sub-step
  const updateProgress = (step, subStep) => {
    const steps = 3; // Updated total steps count
    const progressPerStep = 100 / steps;

    if (step === 1) {
      const progressPerSubStep = progressPerStep / 2;
      setProgress(progressPerSubStep * subStep);
    } else if (step === 2) {
      setProgress(progressPerStep * 2);
    } else if (step === 3) {
      setProgress(100); // Step 3 is final
    }
  };

  const updateStep = (newStep, subStep = 1) => {
    setCurrentStep(newStep);
    setSubStep(subStep);
    updateProgress(newStep, subStep);
  };

  const updateSubStep = (newSubStep) => {
    setSubStep(newSubStep);
    // updateProgress(currentStep, newSubStep);
  };

  const getCurrentStep = () => {
    switch (currentStep) {
    case 1:
      if (subStep === 1) {
        return (
          <SubStep1
            updateStep={updateStep}
            updateSubStep={updateSubStep}
            setError={setError}
          />
        );
      } else if (subStep === 2) {
        return (
          <SubStep2
            updateStep={updateStep}
            updateSubStep={updateSubStep}
            setSelectedPlatform={setSelectedPlatform}
            selectedPlatform={selectedPlatform}
            error={error}
            setError={setError}
          />
        );
      }
      break;
    case 2:
      return <Step2 selectedPlatform={selectedPlatform} />;
    case 3:
      if (subStep === 1) {
        return (
          <Step_3
            selectedPlatform={selectedPlatform}
            error={error}
            setError={setError}
          />
        );
      } else if (subStep === 2) {
        return <Landing />;
      }
      break;
    case 4:
      if (subStep === 1) {
        return (
          <Step_41
            email={{ name: userData.name, email: userData.email }}
            error={error}
            setError={setError}
          />
        );
      } else if (subStep === 2) {
        return <Landing />;
      }
      break;
    default:
      return null;
    }
  };

  const onNext = () => {
    if (currentStep === 1 && subStep === 1 && !eventData?._id) {
      setError({ ...error, default: 'Please select an event.' });
    } else if (currentStep === 1 && subStep === 2 && !selectedPlatform) {
      setError({ ...error, default: 'Please select a platform.' });
    } else if (
      currentStep === 3 &&
      Object.keys(error || {}).filter((key) => !!error?.[key]).length
    ) {
      return;
    } else if (currentStep === 4 && subStep === 1) {
      if (
        Object.keys(error || {}).filter((key) => !!error?.[key]).length ||
        !userContactData?.phone ||
        !userContactData?.name
      )
        return;
      else setIsCheckModalOpen(true);
    } else {
      setError({});
      if (currentStep === 1 && subStep < 2) {
        updateSubStep(subStep + 1);
      } else if (currentStep === 2) {
        setIsModalOpen(true);
      } else if (currentStep === 3) {
        mixpanel.track("Ticket_Pricing_Completed", {
          "event_name": eventData?.name,
          "event_id": eventData?._id,
          "category_name": verificationData?.eventCategory || null,
          "ticket_price": ticketData?.price || null,
          "ticket_quantity": ticketData?.count || null,
          "user_id": userData?._id,
          "listing_status": "Ready to List",
          "page_url": window.location.href,
        });
        if (
          validateTicketCount(ticketData?.count, setError) &&
          validateTicketPrice(ticketData?.price, setError, verificationData)
        ) {
          if (userData?.whatsappNumber) setIsCheckModalOpen(true);
          else {
            updateStep(currentStep + 1);
            updateSubStep(1);
          }
        }
      } else {
        updateStep(currentStep + 1);
        updateSubStep(1);

         mixpanel.track("Platform_Next_Cta_Clicked", {
          "event_id": eventData?._id,
          "event_name": eventData?.name,
          "user_id": userData?._id|| "Anonymous",
          "page_url": window.location.href,
    });
      }
    }
  };

  const onBack = () => {
    if (currentStep === 1 && subStep > 1) {
      updateSubStep(subStep - 1);
    } else if (currentStep === 1) {
      navigate('/');
    } else if (currentStep === 2) {
      updateStep(1, 2);
    } else {
      updateStep(currentStep - 1);
    }
  };

  const postTicket = () => {
    bookTicket(
      {
        eventID: eventData?._id,
        userID: userData?._id,
        ticketCount: ticketData?.count,
        categoryName: verificationData?.eventCategory,
        ticketPrice: ticketData?.price,
        termsAgreed: true,
        maxPrice: verificationData?.totalPrice,
        maxQuantity: verificationData?.quantity,
        verificationId: verificationData?.verificationId,
        bookingId: verificationData?.bookingId,
        platform: selectedPlatform?.label,
      },
      () => {
        setIsCheckModalOpen(false);
        updateStep(4, 2);
      },
      () => {
        setIsCheckModalOpen(false);
        notify('error', 'Failed to list your ticket!');
        navigate('/');
      },
    );
  };

  const handleCheckModalConfirm = () => {
    if (!userData?.whatsappNumber) {
      updateUserContact(
        {
          name: userContactData?.name,
          whatsappNumber: userContactData?.phone,
        },
        postTicket,
        () => {
          setIsCheckModalOpen(false);
          notify('error', 'Failed to list your ticket!');
          navigate('/');
        },
      );
    } else {
      postTicket();
    }
  };

  const handlePricingStep = () => {
    setIsModalOpen(false);
    updateStep(3); // Move to the pricing step
  };

  return (
    <div className="sell-tickets-container mt-16 md:mt-24 w-full px-6 sm:px-6 md:px-[130px] lg:px-[200px] xl:px-[400px] items-center flex flex-col flex-shrink-0 mx-auto">
      <div className="hidden w-full lg:block">
        {currentStep !== 4 && (
          <ProgressBar
            className="pt-7"
            steps={3} // Updated steps count
            value={progress}
          />
        )}
      </div>
      <div className="sell-tickets-content pb-4 w-full flex flex-1 flex-col overflow-auto">
        {getCurrentStep()}
      </div>
      <div className="bg-white bottom-0 left-0 w-full fixed px-6 md:px-[130px] lg:px-[200px] xl:px-[400px]">
        {currentStep !== 4 && (
          <div className="block lg:hidden w-full">
            <ProgressBar
              steps={3} // Updated steps count
              value={progress}
            />
          </div>
        )}
        {(currentStep !== 4 || subStep !== 2) && (
          <Footer
            onClickNext={() => onNext()}
            onClickBack={onBack}
            currentStep={currentStep}
            subStep={subStep}
            isModalOpen={isModalOpen}
            userContactData={userContactData}
          />
        )}
      </div>
      <ForwardModal
        isOpen={isModalOpen}
        selectedPlatform={selectedPlatform}
        onClose={() => setIsModalOpen(false)}
        proceedToStep3={handlePricingStep}
      />
      <Step42
        isOpen={isCheckModalOpen}
        onConfirm={handleCheckModalConfirm}
        onClose={() => setIsCheckModalOpen(false)}
      />
    </div>
  );
};

export default SellTickets;
